import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  // Le chiamate PVGIS passano verso un dominio esterno via proxy:
  // evitiamo header custom che possono essere bloccati da WAF upstream.
  if (req.url.startsWith('/pvgis')) {
    return next(req);
  }

  // se l’URL comincia con uno dei domini esclusi -> bypass
  const isExcluded = environment.excludedDomains.some((domain) =>
    req.url.startsWith(domain),
  );

  if (isExcluded) {
    return next(req);
  }

  // altrimenti aggiungo l’header
  return next(
    req.clone({
      headers: req.headers.append('baseUrl', window.location.hostname),
    }),
  );
};
